import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=48940fdc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=48940fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48940fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48940fdc')) {
      api.createRecord('48940fdc', component.options)
    } else {
      api.reload('48940fdc', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=48940fdc&scoped=true&", function () {
      api.rerender('48940fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Footer.vue"
export default component.exports